import React from 'react';
import { Card, Row, Col, Form, Input, Button, Table, Tag, Select,
	DatePicker, Empty, Typography, Tooltip,
} from 'antd';
import {
	CarOutlined, PrinterOutlined, CloseCircleOutlined, RollbackOutlined,
	RedoOutlined, SearchOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import { Helmet } from 'react-helmet';
import Config from '../../Config';
import moment from 'moment';

const { Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

const configClass = {
	title: 'Histori Penggunaan Notice',
	apiUrl: {
		histori: 'transaksi/api/histori-notice/',
		upt: 'pegawai/api/upt/',
		kabupaten: 'master/api/kabupaten/',
	},
	breadCrumb: [<span><CarOutlined /> Transaksi</span>, 'Histori Penggunaan Notice'],
};

const JENIS_INFO = {
	cetak: { color: '#e6f0fb', border: '#91b4e8', text: '#1e4d8a', label: 'Notice Diterbitkan', icon: <PrinterOutlined /> },
	rusak: { color: '#fff1f0', border: '#ffa39e', text: '#cf1322', label: 'Notice Rusak', icon: <CloseCircleOutlined /> },
	batal_validasi: { color: '#fffbe6', border: '#ffe58f', text: '#ad6800', label: 'Batal Validasi', icon: <RollbackOutlined /> },
};

const JenisTag = ({ value }) => {
	const s = JENIS_INFO[value] || { color: '#f5f5f5', border: '#d9d9d9', text: '#666', label: value };
	return (
		<Tag icon={s.icon} style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: s.color, borderColor: s.border, color: s.text }}>
			{s.label}
		</Tag>
	);
};

const config = new Config();

class HistoriNotice extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			isMobile: window.innerWidth <= 768,
			loading: false,
			listHistori: [],
			pagination: { current: 1, pageSize: 25, total: 0 },

			filterJenis: undefined,
			filterKodeNotice: '',
			filterNomorNotice: '',
			filterNomorPolisi: '',
			filterUptId: undefined,
			filterKabupatenId: undefined,
			// Default: tampilkan histori hari ini saja.
			filterTanggal: [moment(), moment()],

			loadingUpt: false, listUpt: [],
			loadingKabupaten: false, listKabupaten: [],
		};
	}

	componentDidMount() {
		this.props.initHandler();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
		this.fetchHistori();
		this.fetchKabupatenList();
		this.initKabupatenFromCookie();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	// Kabupaten yang dipilih pegawai saat login (cookie/redux uptDipilih) -
	// dipakai untuk auto-isi + kunci form Kabupaten pada non-superadmin,
	// sama seperti LapPenggunaanNoticeRusak.jsx.
	_getKabupatenId() {
		try {
			const raw = this.props.uptDipilih;
			if (!raw) return null;
			const obj = typeof raw === 'string' ? JSON.parse(raw) : raw;
			return obj.kabupaten || null;
		} catch {
			return null;
		}
	}

	isKabupatenLocked() {
		return !this.props.is_superuser && Boolean(this._getKabupatenId());
	}

	initKabupatenFromCookie() {
		const kabupatenId = this._getKabupatenId();
		if (kabupatenId) this.setState({ filterKabupatenId: kabupatenId });
		this.fetchUptList('', kabupatenId);
	}

	fetchKabupatenList = (search = '') => {
		this.setState({ loadingKabupaten: true });
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.kabupaten}?limit=200${search ? '&search=' + encodeURIComponent(search) : ''}`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState({ listKabupaten: Array.isArray(data) ? data : (data.results || []) });
				}
				this.setState({ loadingKabupaten: false });
			}).catch(() => this.setState({ loadingKabupaten: false }));
	};

	fetchUptList = (search = '', kabupatenId = this.state.filterKabupatenId) => {
		this.setState({ loadingUpt: true });
		let url = `${configClass.apiUrl.upt}?limit=200`;
		if (kabupatenId) url += `&kabupaten=${kabupatenId}`;
		if (search) url += `&search=${encodeURIComponent(search)}`;
		this.props.ajaxViewHandler('get', url)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState({ listUpt: Array.isArray(data) ? data : (data.results || []) });
				}
				this.setState({ loadingUpt: false });
			}).catch(() => this.setState({ loadingUpt: false }));
	};

	fetchHistori = (page = 1) => {
		const {
			pagination, filterJenis, filterKodeNotice, filterNomorNotice,
			filterNomorPolisi, filterUptId, filterTanggal,
		} = this.state;
		const limit = pagination.pageSize, offset = (page - 1) * limit;
		let params = `?limit=${limit}&offset=${offset}`;
		if (filterJenis) params += `&jenis=${filterJenis}`;
		if (filterKodeNotice) params += `&kode_notice=${encodeURIComponent(filterKodeNotice)}`;
		if (filterNomorNotice) params += `&nomor_notice=${encodeURIComponent(filterNomorNotice)}`;
		if (filterNomorPolisi) params += `&nomor_polisi=${encodeURIComponent(filterNomorPolisi)}`;

		// Backend (HistoriNoticeView) tetap men-scope hasil sesuai level akses
		// pegawai; filter UPT di sini hanya berlaku efektif untuk level yang
		// memang diizinkan lintas-UPT.
		if (filterUptId) params += `&upt_id=${filterUptId}`;

		if (filterTanggal && filterTanggal[0]) params += `&tanggal_dari=${filterTanggal[0].format('YYYY-MM-DD')}`;
		if (filterTanggal && filterTanggal[1]) params += `&tanggal_sampai=${filterTanggal[1].format('YYYY-MM-DD')}`;

		this.setState({ loading: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.histori + params)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg || {};
					this.setState({
						listHistori: data.results || [],
						pagination: { ...pagination, current: page, total: data.count || 0 },
					});
				}
				this.setState({ loading: false });
			}).catch(() => this.setState({ loading: false }));
	};

	handleFilter = () => {
		this.fetchHistori(1);
	};

	handleReset = () => {
		this.setState({
			filterJenis: undefined, filterKodeNotice: '', filterNomorNotice: '',
			filterNomorPolisi: '', filterUptId: undefined, filterKabupatenId: undefined,
			filterTanggal: [moment(), moment()],
		}, () => {
			this.initKabupatenFromCookie();
			this.fetchHistori(1);
		});
	};

	_columns() {
		return [
			{ title: 'Tanggal/Jam', dataIndex: 'created_at', key: 'created_at', width: 150 },
			{ title: 'Jenis', dataIndex: 'jenis', key: 'jenis', width: 170, align: 'center',
				render: (v) => <JenisTag value={v} /> },
			{ title: 'Nomor Notice', key: 'nomor', width: 140,
				render: (_, row) => <Text style={{ fontFamily: 'monospace', fontWeight: 700 }}>{row.kode_notice || ''} {row.nomor_notice}</Text> },
			{ title: 'Nomor Polisi', dataIndex: 'nomor_polisi', key: 'nomor_polisi', width: 130,
				render: (v) => v || <Text type="secondary">—</Text> },
			{ title: 'UPT', dataIndex: 'upt_nama', key: 'upt_nama', render: (v) => v && v !== '-' ? v : <Text type="secondary">—</Text> },
			{ title: 'Oleh', dataIndex: 'oleh', key: 'oleh', render: (v) => v && v !== '-' ? v : <Text type="secondary">—</Text> },
			{ title: 'Sumber', dataIndex: 'sumber', key: 'sumber', width: 130,
				render: (v) => v ? <Tag>{v}</Tag> : <Text type="secondary">—</Text> },
			{ title: 'Keterangan', dataIndex: 'keterangan', key: 'keterangan',
				render: (v) => v || <Text type="secondary">—</Text> },
		];
	}

	render() {
		const {
			isMobile, loading, listHistori, pagination,
			filterJenis, filterKodeNotice, filterNomorNotice, filterNomorPolisi,
			filterUptId, filterKabupatenId, filterTanggal, listUpt, loadingUpt,
			listKabupaten, loadingKabupaten,
		} = this.state;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.histori-notice-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700; font-size: 13px; color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.histori-notice-wrap .ant-table-tbody > tr:hover > td { background: #e8f0fb !important; }
						.histori-notice-wrap .ant-table-tbody > tr:nth-child(even) > td { background: #fafafa; }
						.histori-notice-wrap .ant-table-tbody > tr:nth-child(even):hover > td { background: #e8f0fb !important; }
					`}</style>
				</Helmet>


				<Card className="histori-notice-wrap" style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>
					<div style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
					}}>
						<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
							<PrinterOutlined style={{ marginRight: 8 }} />
							{configClass.title}
						</div>
						<Tooltip title="Refresh data">
							<Button icon={<RedoOutlined />} style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
								onClick={() => this.fetchHistori(pagination.current)}>
								{!isMobile && 'Refresh'}
							</Button>
						</Tooltip>
					</div>

					<div style={{ padding: '16px 20px 0' }}>
						<Text type="secondary" style={{ fontSize: 12 }}>
							Gabungan riwayat nomor notice: kapan diterbitkan saat pembayaran (cetak), serta kapan dibatalkan (rusak/batal validasi) - baik yang diproses langsung maupun lewat persetujuan Kasi Penetapan.
						</Text>
					</div>

					<div style={{ padding: 16 }}>
						<Form layout="vertical" onFinish={this.handleFilter}>
							<Row gutter={12}>
								<Col xs={12} sm={6} md={4}>
									<Form.Item label="Kabupaten" style={{ marginBottom: 10 }}>
										<Select allowClear showSearch placeholder="Semua kabupaten" loading={loadingKabupaten}
											disabled={this.isKabupatenLocked()}
											filterOption={false} onSearch={(v) => this.fetchKabupatenList(v)}
											value={filterKabupatenId}
											onChange={(v) => this.setState({ filterKabupatenId: v, filterUptId: undefined }, () => this.fetchUptList('', v))}>
											{listKabupaten.map((kab) => (
												<Option key={kab.id} value={kab.id}>{kab.name}</Option>
											))}
										</Select>
									</Form.Item>
								</Col>
								<Col xs={12} sm={6} md={4}>
									<Form.Item label="UPT" style={{ marginBottom: 10 }}>
										<Select allowClear showSearch placeholder="Semua UPT" loading={loadingUpt}
											filterOption={false} onSearch={(v) => this.fetchUptList(v)}
											value={filterUptId} onChange={(v) => this.setState({ filterUptId: v })}>
											{listUpt.map((upt) => (
												<Option key={upt.id} value={upt.id}>{upt.nama}</Option>
											))}
										</Select>
									</Form.Item>
								</Col>
								<Col xs={12} sm={6} md={4}>
									<Form.Item label="Jenis" style={{ marginBottom: 10 }}>
										<Select allowClear placeholder="Semua jenis" value={filterJenis}
											onChange={(v) => this.setState({ filterJenis: v })}>
											<Option value="cetak">Notice Diterbitkan</Option>
											<Option value="rusak">Notice Rusak</Option>
											<Option value="batal_validasi">Batal Validasi</Option>
										</Select>
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={12}>
								<Col xs={12} sm={6} md={4}>
									<Form.Item label="Kode Notice" style={{ marginBottom: 10 }}>
										<Input placeholder="contoh: A" value={filterKodeNotice}
											onChange={(e) => this.setState({ filterKodeNotice: e.target.value })} />
									</Form.Item>
								</Col>
								<Col xs={12} sm={6} md={4}>
									<Form.Item label="Nomor Notice" style={{ marginBottom: 10 }}>
										<Input placeholder="nomor seri" value={filterNomorNotice}
											onChange={(e) => this.setState({ filterNomorNotice: e.target.value })} />
									</Form.Item>
								</Col>
								<Col xs={12} sm={6} md={4}>
									<Form.Item label="Nomor Polisi" style={{ marginBottom: 10 }}>
										<Input placeholder="contoh: KH1234AB" value={filterNomorPolisi}
											onChange={(e) => this.setState({ filterNomorPolisi: e.target.value })} />
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={12}>
								<Col xs={24} sm={12} md={4}>
									<Form.Item label="Rentang Tanggal" style={{ marginBottom: 10 }}>
										<RangePicker style={{ width: '100%' }} value={filterTanggal}
											onChange={(v) => this.setState({ filterTanggal: v })} />
									</Form.Item>
								</Col>
							</Row>
							<div style={{ textAlign: 'right' }}>
								<Button onClick={this.handleReset} style={{ marginRight: 8 }}>Reset</Button>
								<Button type="primary" icon={<SearchOutlined />} htmlType="submit"
									style={{ background: '#1e4d8a', borderColor: '#1e4d8a' }}>
									Cari
								</Button>
							</div>
						</Form>
					</div>

					<Table
						columns={this._columns()}
						dataSource={listHistori}
						loading={loading}
						rowKey={(row, i) => `${row.jenis}-${row.tagihan_id}-${row.nomor_notice}-${i}`}
						scroll={{ x: 'max-content' }}
						size="middle"
						locale={{ emptyText: <Empty description="Belum ada histori notice" /> }}
						pagination={{
							current: pagination.current, pageSize: pagination.pageSize, total: pagination.total,
							showSizeChanger: true, pageSizeOptions: ['25', '50', '100'],
							showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
							onChange: (page, pageSize) => this.setState(prev => ({ pagination: { ...prev.pagination, pageSize } }), () => this.fetchHistori(page)),
						}}
					/>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = state => state.configReducers;
export default connect(mapStateToProps, { initHandler, ajaxViewHandler, ajaxHandler, setConfig })(HistoriNotice);
